import { render, staticRenderFns } from "./RuteDetail.vue?vue&type=template&id=35b4ee04&scoped=true"
import script from "./RuteDetail.vue?vue&type=script&lang=js"
export * from "./RuteDetail.vue?vue&type=script&lang=js"
import style0 from "./RuteDetail.vue?vue&type=style&index=0&id=35b4ee04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4ee04",
  null
  
)

export default component.exports